import { fetch } from '@utils/utils';

export const getGlobalSearch = async ({ url, globalSearch, ...rest }) => {
  try {
    const response: any = await fetch(
      `${url}?pageSize=1&page=0&allowDeleted=false&universalFilter.value=${globalSearch}`,
      {
        method: 'GET',
        headers: new Headers({ 'Content-Type': 'application/json' })
      }
    );
    const { count } = await response.json();

    if (count) {
      return { count, url, globalSearch, ...rest };
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/components/sidebar/globalSearch/_globalSearchActions.ts